// UserProfile

import { User } from "../classes/User";

export interface IUserProfile {
    // userData: IUserProfile;
    id: number;
    firstName: string;
    lastName: string;
    roleID: number;
    roleName: string;
    isAddRequests?: boolean;
    isApproveRequests?: boolean;
    photoUrl: string;
  }